import * as API from "middleware/api";

export const addLimitRequest = (data) => API.executeWithAccessToken("/temporary.limit.increase.request", { ...data });

export const loadTemporaryLimitPre = () => API.executeWithAccessToken("/temporary.limit.increase.pre", {});

export default addLimitRequest;
